import store from '@shared/store/index';

export function usePodcastManager() {
  /**
   * Добавляет подкаст в хранилище, если его еще нет
   * @param {Object} podcastData - Данные подкаста
   * @returns {boolean} - Был ли добавлен подкаст
   */
  const addPodcastToStore = (podcastData) => {
    if (!podcastData?.id) {
      console.warn('Invalid podcast data: missing id');
      return;
    }
    const exists = store.state.Audioplayer.list?.hasOwnProperty(podcastData.id);
    if(exists) return;
    store.dispatch('Audioplayer/addPodcastToList', podcastData);
  };

  return {
    addPodcastToStore,
  };
}